import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import * as signalR from '@microsoft/signalr';
import ToastBulkDownloads from '../PortalListing/components/ToastBulkDownloads';

export default function PortalNotifications() {
  const connectionRef = useRef<signalR.HubConnection | null>(null);
  const [isConnected, setIsConnected] = React.useState(false);
  const [showPreparingFiles, setShowPreparingFiles] = React.useState(false);
  const [showDownloadReady, setShowDownloadReady] = React.useState(false);
  const [headingPreparing, setHeadingPreparing] = React.useState('');
  const [textPreparing, setTextPreparing] = React.useState('');
  const [headingReady, setHeadingReady] = React.useState('');
  const [textReady, setTextReady] = React.useState('');
  const [ctaTextReady, setCtaTextReady] = React.useState('');
  const [downloadUrl, setDownloadUrl] = React.useState<string | null>(null);

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl('/downloadsnotifications', {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect()
      .build();

    connection.on('sendNotification', (message: string) => {
      // Handle toast notifications directly in context
      try {
        const data = JSON.parse(message);

        if (typeof data?.url === 'string' && data.url.length > 0) {
          !!data?.heading && setHeadingReady(data.heading);
          !!data?.text && setTextReady(data.text);
          setDownloadUrl(data.url);
          !!data?.cta && setCtaTextReady(data.cta);
          setShowPreparingFiles(false);
          setShowDownloadReady(true);
        } else {
          !!data?.heading && setHeadingPreparing(data.heading);
          !!data?.text && setTextPreparing(data.text);
          setShowPreparingFiles(true);
          setShowDownloadReady(false);
        }
      } catch (error) {
        console.error('Error parsing notification:', error, 'Raw message:', message);
      }
    });

    connection.onreconnecting(() => {
      setIsConnected(false);
    });

    connection.onreconnected(() => {
      setIsConnected(true);
    });

    connection
      .start()
      .then(() => {
        setIsConnected(true);
        connectionRef.current = connection;
      })
      .catch((err: Error) => console.error('SignalR connection error:', err));

    return () => {
      connection.stop();
    };
  }, []);

  return (
    <>
      {showPreparingFiles &&
        createPortal(
          <ToastBulkDownloads
            setShowPreparingFiles={setShowPreparingFiles}
            type="preparing"
            svgIconName="cloud-download"
            heading={headingPreparing}
            text={textPreparing}
          />,
          document.body
        )}
      {showDownloadReady &&
        createPortal(
          <ToastBulkDownloads
            setShowDownloadReady={setShowDownloadReady}
            downloadUrl={downloadUrl}
            type="ready"
            svgIconName="check-circle-medium"
            heading={headingReady}
            text={textReady}
            ctaText={ctaTextReady}
          />,
          document.body
        )}
    </>
  );
}
